import React from "react";
// import Input from "./Input"
import { Input, Dropdown } from "semantic-ui-react";
import _ from "lodash";

const durationTypes = [
  {
    id: "days",
    timeLength: 24 * 60 * 60,
    label: () => I18n.t("base.x_days", { count: "" }),
  },
  {
    id: "hours",
    timeLength: 60 * 60,
    label: () => I18n.t("base.x_hours", { count: "" }),
  },
  {
    id: "minutes",
    timeLength: 60,
    label: () => I18n.t("base.x_minutes", { count: "" }),
  },
  {
    id: "seconds",
    timeLength: 1,
    label: () => I18n.t("base.x_seconds", { count: "" }),
  },
];

export default class TimeDurationControl extends React.PureComponent {
  state = {
    durationTypeTimeLength: null,
  };
  defaultProps = {
    durationTypeTimeLengths: durationTypes.map((t) => t.timeLength),
  };

  componentDidMount() {
    this._generateDurationOptions();
  }

  componentWillReceiveProps(nextProps) {
    if (
      !_.isEqual(
        this.props.durationTypeTimeLengths,
        nextProps.durationTypeTimeLengths || this.props.durationTypeTimeLengths
      )
    ) {
      this._generateDurationOptions(nextProps.durationTypeTimeLengths || this.props.durationTypeTimeLengths);
    }
  }

  _generateDurationOptions(durationTypeTimeLengths = this.props.durationTypeTimeLengths) {
    this.durationOptions = durationTypes
      .filter(({ timeLength }) => durationTypeTimeLengths.includes(timeLength))
      .map((type) => ({
        text: type.label(),
        value: type.timeLength,
      }));

    const { value } = this.props;
    const newDurationTypeTimeLength = (
      this.durationOptions.find((opt) => Math.ceil(value || 0) % opt.value === 0) ||
      this.durationOptions[this.durationOptions.timeLength - 1]
    ).value;
    this.state.durationTypeTimeLength !== newDurationTypeTimeLength &&
      this.setState({ durationTypeTimeLength: newDurationTypeTimeLength });
  }

  render() {
    const { className, onFocus, onBlur, onChange, value, durationTypeTimeLengths, ...rest } = this.props;
    const { durationTypeTimeLength } = this.state;
    const handleDropdownChange = (event, { value: newDurationTypeTimeLength }) => {
      newDurationTypeTimeLength = +newDurationTypeTimeLength;
      if (newDurationTypeTimeLength === durationTypeTimeLength) {
        return;
      }
      this.setState({ durationTypeTimeLength: newDurationTypeTimeLength });
      value !== null && onChange && onChange((value / durationTypeTimeLength) * newDurationTypeTimeLength);
    };
    const label = (
      <Dropdown
        compact
        selection
        value={durationTypeTimeLength}
        options={this.durationOptions}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={handleDropdownChange}
      />
    );

    return (
      <Input
        {...rest}
        className={`TimeDurationControl ` + (className || "")}
        type="number"
        min="0"
        step="1"
        value={value === null ? "" : value / durationTypeTimeLength}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange && ((event, { value }) => onChange(+value ? +value * durationTypeTimeLength : 0))}
        label={label}
        labelPosition="right"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/TimeDuration.jsx